import React, { useState } from 'react';
import FileList from '../../shared/components/FileList';
import TemplateList from '../../shared/components/TemplateList';
import ActionBar from '../../shared/components/ActionBar';
import ActivityList from '../../shared/components/ActivityList';
import axiosConfig from '@/utils/axiosConfig';
import axios from 'axios';
import UploadStatusType, { UploadStatus } from '@/utils/FilesUtils';
import useToken from '@/shared/useToken';

const HomePage: React.FC = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [selectedProject, setSelectedProject] = useState<string>('');
  const [selectedFileIndex, setSelectedFileIndex] = useState<number | null>(
    null,
  );
  const [isActivitySectionOpen, setIsActivitySectionOpen] = useState(false);
  const [uploadStatus, setUploadStatus] = useState<UploadStatusType>();
  const [uploadingFileName, setUploadingFileName] = useState('');
  const getToken = useToken();

  const handleFileSelect = (index: number | null) => {
    setSelectedFileIndex(index);
  };

  const handleFileAdd = async (newFile: File) => {
    if (selectedProject !== '') {
      setIsActivitySectionOpen(true);
      setUploadStatus({ status: UploadStatus.UPLOADING });
      setUploadingFileName(newFile.name);
      const token = await getToken();
      axiosConfig
        .post(
          '/upload_file',
          {
            group: selectedProject,
            file_name: newFile.name,
            email: token.userInfo.email,
            gid: token.userInfo.gid,
          },
          {
            headers: {
              Authorization: `Bearer ${token.accessToken}`,
            },
          },
        )
        .then((response) => {
          const requestUrl = response.data.upload_url;
          if (requestUrl) {
            axios
              .post(
                requestUrl.url,
                {
                  ...requestUrl.fields,
                  file: newFile,
                  "x-amz-meta-email": token.userInfo.email,
                  "x-amz-meta-gid": token.userInfo.gid,
                },
                {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                },
              )
              .then(() => {
                setUploadStatus({ status: UploadStatus.UPLOADED });
                setFiles((prevFiles) => {
                  if (!prevFiles.find((elem) => elem.name === newFile.name)) {
                    return [...prevFiles, newFile];
                  }
                  return prevFiles;
                });
              })
              .catch((error) => {
                console.log(error);
                setUploadStatus({
                  status: UploadStatus.FAILED,
                  description: error.response.data.detail || ''
                });
              });
          }
        })
        .catch((error) => {
          console.log(error);
          setUploadStatus({
            status: UploadStatus.FAILED,
            description: error.response.data.detail || '',
          });
        });
    }
  };

  const handleFileDelete = () => {
    if (selectedFileIndex !== null) {
      setFiles((prevFiles) =>
        prevFiles.filter((_, index) => index !== selectedFileIndex),
      );
      setSelectedFileIndex(null);
    }
  };

  const handleSync = () => {
    //sync files
  };

  const handleOpenActivity = () => {
    setIsActivitySectionOpen((prev) => !prev);
  };

  return (
    <div className="homePage">
      <div className="homePage-grid">
        <ActionBar
          onClickDelete={handleFileDelete}
          onSync={handleSync}
          onClickUpload={handleFileAdd}
          onClickOpenActivity={handleOpenActivity}
        />
        <div className="bucketExplorer-container">
          <div className="bucketExplorer-templateList">
            <TemplateList
              onSelectProject={setSelectedProject}
              selectedProject={selectedProject}
            />
          </div>
          <div className="bucketExplorer-fileList">
            <FileList
              files={files}
              selectedFileIndex={selectedFileIndex}
              onFileSelect={handleFileSelect}
              onFileAdd={handleFileAdd}
              uploadStatus={uploadStatus}
              uploadingFileName={uploadingFileName}
            />
          </div>
          <div
            className={`bucketExplorer-activityList${
              isActivitySectionOpen ? '_open' : ''
            }`}
          >
            <ActivityList
              isOpen={isActivitySectionOpen}
              uploadingFileName={uploadingFileName}
              uploadStatus={uploadStatus}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
